import styled from 'styled-components'
import { PARAM_SORT_TYPE, PARAM_SORT_KEYS } from '../../constants'

type Props = {
  sortType: PARAM_SORT_TYPE
  setSortType: (sortType: PARAM_SORT_TYPE) => void
  sortList: { type: string; title: string }[]
}

// TODO: ionic 관련 수정 필요
export const SelectSort = ({ sortType, setSortType, sortList }: Props) => {
  return (
    <SelectContainer>
      <select
        aria-label="sort"
        // placeholder="기본 정렬"
        value={PARAM_SORT_KEYS[sortType]}
        onChange={(e) => setSortType(e.target.value as PARAM_SORT_TYPE)}
        className="artipio-action-sheet"
        // okText={'적용'}
      >
        {sortList.map(({ title, type }, i) => (
          <option key={i} value={type}>
            {title}
          </option>
        ))}
      </select>
    </SelectContainer>
  )
}

const SelectContainer = styled.div`
  display: flex;
  justify-content: end;
  padding: 5px 0;
  font-size: 13px;
`
